import { CheckboxProps as MUICheckboxProps, FormControl } from '@mui/material';
import { Field } from 'formik';
import { Checkbox as FormikCheckbox, CheckboxWithLabel } from 'formik-mui';

export interface CheckboxProps extends MUICheckboxProps {
    label?: string;
}

export const Checkbox = (props: CheckboxProps) => {
    const { label, ...rest } = props;

    return (
        <FormControl component="fieldset">
            <Field
                type="checkbox"
                component={label ? CheckboxWithLabel : FormikCheckbox}
                label={{ label }}
                {...rest}
            />
        </FormControl>
    );
};
